import ReactDOM from 'react-dom/client'
import '../styles/application.css'
import { App } from '../components/App'

// Mount React app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root')
  if (container) {
    const root = ReactDOM.createRoot(container)
    root.render(<App />)
  }
})